module.exports = __webpack_public_path__ + "static/img/RAPS-B_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPS-B_1.png
// module id = V5ot
// module chunks = 0